import { createGlobalStyle  } from "styled-components";

const GlobalStyle=createGlobalStyle`

*,*::before,*::after,h1,h2,h3,h4,h5,h6{
  margin:0;
  padding:0;
}
h1,h2,h3,h4,h5,h6{
  display:inline-block;
}
body{
  margin:0;
  padding:0;
  overflow-x:hidden;
  font-family:'Source Sans Pro',sans-serif;
  
  /* Prevent hover states from getting stuck on mobile */
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Reset any stuck hover states on touch devices */
@media (hover: none) {
  * {
    -webkit-tap-highlight-color: transparent !important;
  }
}
`

export default GlobalStyle